<div class="container_herramienta">
    <img src="assets/img/web/tfph_transp.webp" class="img_toAnimate">
    <div class="alinearIzq">
        <h1 class="txt-section">TufesaPack Horas</h1>
            <div class="descripcion_cont">
            <p>
                <b>Servicio TufesaPack Horas</b><br>
                El servicio TUFESAPACK HORAS garantiza que tus paquetes lleguen en un máximo de 24 horas a partir del momento en que son documentados.
            </p>
            <p>
                <b>Condiciones</b><br>
                Para el servicio de TufesaPack Horas, se permiten envíos de sobre de 0 a 1 kilo y de caja de 0 a 10 kilos. La tarifa se basa en peso volumétrico, aplicable a peso y dimensiones reales del paquete. Solo servicio ocurre - ocurre, no servicio a domicilio. 
            </p>
                <b>Cobertura</b><br>
                El servicio de TufesaPack Horas es válido únicamente en:
                <br><br>
            <ul>
               <li>Envíos saliendo desde la sucursal de Nogales hacia las sucursales de Agua Prieta, Caborca, Cananea, Magdalena, Santa Ana, Hermosillo, Guaymas, Empalme, Ciudad Obregón, Navojoa y Los Mochis.</li>
                <li>Envíos saliendo desde la sucursal de Agua Prieta hacia las sucursales de Nogales, Cananea, Magdalena, Hermosillo, Guaymas, Empalme, Ciudad Obregón y Navojoa.</li>
                <li>Envíos saliendo de la sucursal Cananea hacia las sucursales de Agua Prieta y Hermosillo (solo sucursal terminal Blvd. Luis Encinas #337 Col. Universidad, C.P. 83040, Hermosillo, Son.)</li>
                <li>Envíos saliendo desde la sucursal de Guaymas hacia las sucursales de Nogales, Hermosillo, Empalme, Ciudad Obregón, Navojoa y Los Mochis.</li>
                <li>Envíos saliendo desde la sucursal de Ciudad Obregón hacia las sucursales de Guaymas, Empalme, Hermosillo, Navojoa, Los Mochis.</li>
                <li>Envíos saliendo de la sucursal de Los Mochis hacia las sucursales Nogales, Hermosillo, Guaymas, Empalme, Navojoa, Guasave, Guamúchil, Culiacán y Mazatlán.</li>
                <li>Envíos saliendo de la sucursal de Mazatlán hacia las sucursales Nogales, Hermosillo, Guaymas, Empalme, Ciudad Obregón, Navojoa, Los Mochis, Guasave y Guamúchil.</li>
            </ul>
            <p>
                <b>Tiempo de envío y recolección</b><br>
                TufesaPack Horas aplica y se podrá contratar solamente cuando el cliente realice el envío del paquete de lunes a viernes antes de los siguientes horarios:
            </p>
                <br><br>
                <ul>
                    <li>Cobertura estipulada en Nogales: envíos antes las 12:00 p.m., de lunes a viernes.</li>
                    <li>Cobertura estipulada en Agua Prieta: envíos antes las 12:00 p.m., de lunes a viernes</li>
                    <li>Cobertura estipulada en Cananea: envíos antes de las 12:00 p.m., de lunes a viernes.</li>
                    <li>Cobertura estipulada en Guaymas: envíos antes de las 12:00 p.m., de lunes a viernes.</li>
                    <li>Cobertura estipulada en Ciudad Obregón: envíos antes las 12:00 p.m., de lunes a viernes.</li>
                    <li>Cobertura estipulada en Los Mochis: envíos antes de las 12:00 p.m., de lunes a viernes.</li>
                    <li>Cobertura estipulada en Culiacán: envíos antes de las 11:00 a.m., de lunes a viernes.</li>
                    <li>Cobertura estipulada en Mazatlán: envíos antes de las 12:00 p.m., de lunes a viernes.</li>
                </ul>
           

            <p>
                Para recolectar el paquete, el mismo día, el destinatario deberá de acudir a sucursal a partir de los siguientes horarios:
                <br><br>
            </p>
            <ul>
                <li>Magdalena 2:00 p.m.</li>
                <li>Empalme, Santa Ana y Caborca a las 4:00 p.m.</li>
                <li>Cananea a las 5:00 p.m.</li>
                <li>Ciudad Obregón y Culiacán (módulo Canacintra) a las 6:00 p.m.</li>
                <li>Hermosillo Centro Operativo, Guaymas, Navojoa, Los Mochis, Culiacán (módulo Central) Guamúchil, Guasave y Mazatlán a las 7:00 p.m.</li>
                <li>Agua Prieta y Nogales a las 8:00 p.m.</li>
            </ul>

            <p>
                <b>Compra y Pago</b><br>
                Válido únicamente en compras dentro de las sucursales, no compras digitales. Se acepta pago en efectivo y tarjeta (donde se cuente con este método de pago). Válido en envío pagado, no por cobrar ni contratos prepago.
            </p>

            <p>
                <b>Garantía</b><br>
                El servicio TufesaPack Horas cuenta con una garantía la cual abarca en que si el envío no llega dentro del tiempo estipulado, se otorga 1 envío gratis, servicio ocurre - ocurre, peso hasta 10 kilos y mismos destinos que se contrataron. Se tendrá 30 días posteriores al envío, para hacer válida esta garantía.
            </p>

            <p>
                <b>Políticas</b><br>
                Las condiciones del servicio están sujetas a las políticas estándar de TufesaPack®, y se reserva el derecho de modificar o cancelar este servicio en cualquier momento sin previo aviso.”
            </p>
        </div>
    </div>
</div>
